import React, { useState, useEffect, useCallback } from 'react';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';
import moment from 'moment';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Snackbar from '../snackbar';
import UploadButton from './UploadButton';
import UploadStatus from './UploadStatus';
import _ from 'lodash';

import { Create } from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const CreateProofOfPayment = (props) => {
    // props.location.query.order_number
  const navigate = useNavigate();
  const [orderNumber, setOrderNumber] = useState('');
  const [selectedMOP, setSelectedMOP] = useState('');
  const [selectedFile, setSelectedFile] = useState();
  const [enableSave, setEnableSave] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);
  const [fileSizeStatus, setFileSizeStatus] = useState(false);
  const [noOrderFound, setNoOrderFound] = useState(true);
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [business, setBusiness] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [businessId, setBusinessId] = useState('');
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

//   const [modeOfPayment] = useState(props.user.settings_data.PROOF_OF_PAYMENT_FORM.mode_of_payment);
  const [modeOfPayment,setModeOfPayment] = useState('');
  const [formSettings, setFormSettings] = useState('');
  // console.log('propssss=>', props.location.query.order_number);

  useEffect(()=> {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    fetch(`${apiUrl}/so_business_list`, options)
      .then(res => {
        return res.json();
      }).then(jsonD => {
        console.log('jsonD ===>', jsonD)
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;

        setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
        setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
      });
  },[]);

  const handleChange = e => {
    console.log('hiiii', e);
    setBusinessId(e.id);
    setSelectedOption([]);
    console.log('saleOffNameSapCode in handleChange', saleOffNameSapCode);
    const arr = [...originalList]
    
    let result = arr && arr.filter(item => [e] && [e].filter(i => i.id === item.id).length === 0);
    console.log('////',result);
    if ([e] === null) {
      result = [...originalList];
      setBusiness([]);
    }
    setBusiness([e]);
    setSaleOffNameSapCode(result);
  };

  const cancelClick = () => {
    setBusiness([]);
    setBusinessId('');
    setSelectedOption([]);
    setSaleOffNameSapCode(originalList);
  }

  const cancelAsyncClick = () => {
    setOrderNumber('')
    setSelectedOption([])
  }


  const sendOrderQuery = (q) => {
    if (!q) {
      setNoOrderFound(true);
      return;
    }

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'POST';
    options.body = JSON.stringify({order_number: q,});
    fetch(`${apiUrl}/sap_digital_orders/verify_order_number`, options)
    .then(res => {
        return res.json();
    })
    .then(json => {
        console.log('.k.k.kk', json);
        setNoOrderFound(json.order_exist);
    }).catch((error) => {
        console.log('error==>', error);
    });
  };

  const delayedQuery = useCallback(_.debounce(q => sendOrderQuery(q), 500), []);

  const handleOrderNumberChange = option => {
    const value = option.order_no;
    console.log('handle of change ',option,value);
    setSelectedOption(option);
    
    if(option && option.business) {
      setBusinessId(option.business);
    }
    setOrderNumber(value);
    if (!(value && value.trim())) setNoOrderFound(true);
    delayedQuery(value);
  };

  const handleMOPChange = (item) => {
    setSelectedMOP(item);
  };

  const handleFileSelect = (file) => {
    setSelectedFile(file);
  };

  const handleInvalidFileSubmit = () => {
    setUploadFailed(true);
    setEnableSave(false);
    setTimeout(() => {
      setUploadFailed(false);
    }, 3000);
  };

  const onInvalidFileSize = () => {
    setFileSizeStatus(true);
    setTimeout(() => {
      setFileSizeStatus(false);
    }, 3000);
  };

  const sumbitForm = () => {
    // const splitBusinessId = business[0].id;
    setOnSaveDisabled(true);

    const stateData = localStorage.getItem('__state');
    const userData = stateData ? JSON.parse(stateData) : false;

    const formData = new FormData();
    formData.append('file_url', selectedFile);
    formData.append('order_number', orderNumber);
    formData.append('mode_of_payment', selectedMOP);
    // formData.append('business', splitBusinessId)
    formData.append('business_id', businessId);
    // const targetUrl = `${props.user._links.business.href}/proof_of_payments`;
    // props.addProofOfPay({ targetUrl, formData });
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'POST';

    for (var key of formData.entries()) {
        console.log(key[0] + ', ' + key[1]);
    }
    options.body = formData;
    fetch(`${apiUrl}/proof_of_payments`, {
        method: 'POST',
        body: formData,
        headers: {
            'Authorization': userData._token,
        }
    })
    .then(res => {
        return res.json();
    })
    .then(json => {
        console.log('.............', json);
        setShowSnackbar(true);
        setTimeout(()=> {navigate(-1)},1000);
    }).catch((error) => {
        console.log('error==>', error);
    });
  };

  const mapOptionsToValues = options => {
    console.log('.../////......//..',options);
    return options.map(option => ({
      value: option.id,
      label: option.order_number + ' - ' + moment(option.delivery_date_from).format('DD/MM/YYYY'),
      order_no: option.order_number,
      business: option.business_id
    }));
  };

  const promiseOptions = q =>{
    console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhh',q);
    if (!q) {
        setNoOrderFound(true);
        return;
    }
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    // options.body = JSON.stringify({order_number: q,});
    const _url = businessId ? `${apiUrl}/sap_digital_app_orders?filter=%7B"business_id"%3A${businessId}%2C"order_number"%3A%22${q}%22%7D` : `${apiUrl}/sap_digital_app_orders?filter=%7B%22order_number%22%3A%22${q}%22%7D`;
    // const _url =  `${apiUrl}/sap_digital_app_orders?filter=%7B"business_id"%3A${businessId}%2C"order_number"%3A%22${q}%22%7D`;
    return new Promise(resolve => {
        fetch(_url, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            console.log('.k.k.kk', json);
            setNoOrderFound(json.order_exist);
            resolve(mapOptionsToValues(json.data));
        }).catch((error) => {
            console.log('error==>', error);
        });
    });
  }


  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    // const formSetting = props.user.settings_data.PROOF_OF_PAYMENT_FORM;
    console.log(',,,,,,,,,,,,,,',formSetting);
    const orderNumberRequired = formSetting.proof_of_payment_form.order_number.required;

    setFormSettings(formSetting.proof_of_payment_form);

    const mop = formSetting.proof_of_payment_form.mode_of_payment;
    setModeOfPayment(formSetting.proof_of_payment_form.mode_of_payment);
    const modeOfPaymentRequired = formSetting.proof_of_payment_form.mode_of_payment.required;

    const valid = (((orderNumberRequired && orderNumber) || !orderNumberRequired) &&
      ((modeOfPaymentRequired && mop) || !modeOfPaymentRequired));
    setEnableSave(valid && !!selectedFile);
  }, [orderNumber, selectedMOP, selectedFile, noOrderFound]);

  // console.log('business id offfffffff', businessId);

  return (
    formSettings ?
    <Create title="Proof of Payment" {...props}>
    {/* <SimpleForm redirect="list"> */}
    <div className={`proof-of-payment-form-page`} >
            <div className="pop-order-number-input">
              <label><span>Sold to<sup className="asterisk">*</sup></span>
              </label>
            <div className="select-retailer">
                <Select
                value={business}
                onChange={handleChange}
                options={saleOffNameSapCode}
                />
                <button onClick={cancelClick}>Clear</button>
            </div>
            </div>
          {
          formSettings.order_number.show &&
            <div className="pop-order-number-input">
              <label><span>Order number<sup className="asterisk">*</sup></span>
              </label>
              {/* <input
                type="text"
                className="lr-text-input__input"
                onChange={handleOrderNumberChange}
                value={orderNumber}
              /> */}

                <div className="select-retailer">
                <AsyncSelect 
                    // cacheOptions 
                    defaultOptions
                    value={selectedOption} 
                    onChange={handleOrderNumberChange} 
                    loadOptions={promiseOptions} 
                />
                 <button onClick={cancelAsyncClick}>Clear</button>
                </div>
            </div>
          }
          {
          formSettings.mode_of_payment.show &&
            <div className="pop-payment-method-container">
              <label><span>Payment method<sup className="asterisk">*</sup></span>
              </label>
              <div className="pop-payment-method">
                {
                  Object.keys(modeOfPayment.values).map(item => (
                    <div className="radio" key={item}>
                      <label htmlFor={item}>
                        <input
                          type="radio"
                          id={item}
                          name="mode_of_payment"
                          value={item}
                          checked={selectedMOP === item}
                          onChange={() => handleMOPChange(item)}
                        />
                        {modeOfPayment.values[item]}
                      </label>
                    </div>
                  ))
                }
              </div>
            </div>
          }
          <div>
            {/* {selectedFile} */}
            <UploadButton
              onInvalidFileSubmit={handleInvalidFileSubmit}
              onInvalidFileSize={onInvalidFileSize}
              selectedFile={handleFileSelect}
            />
          </div>
          <UploadStatus
            uploading={uploading}
            uploaded={uploaded}
            failed={uploadFailed}
            sizeStatus={fileSizeStatus}
          />
          <div className="so-save-button">
            <button
              onClick={sumbitForm}
              disabled={!enableSave || !noOrderFound || !businessId || onSaveDisabled}
            >
              <span>Save</span>
            </button>
          </div>
        {
          showSnackbar &&
          <Snackbar message="Element Created" />
        }
      </div>
    {/* </SimpleForm> */}
    </Create>
    :
    <div>loadding</div>
  );
};